/*
 * @Author: your name
 * @Date: 2020-11-30 14:08:16
 * @LastEditTime: 2020-12-01 00:55:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\storage.js
 */
export function setCookie (a, b, c) {
  const d = new Date()
  d.setDate(d.getDate() + c)
  document.cookie = a + '=' + b + ';expires=' + d
}
export function delCookie (a) {
  setCookie(a, 1, -1)
}
export function getCookie (a) {
  for (let b = document.cookie.split('; '), c = 0; c < b.length; c++) {
    const d = b[c].split('=')
    if (d[0] === a) return d[1]
  }
  return ''
}
export function setCookieJson (a, b, c) {
  const d = JSON.stringify(b)
  this.setCookie(a, d, c)
}
export function getCookieJson (a) {
  let c = this.getCookie(a)
  if (c) {
    c = JSON.parse(c)
  }
  return c
}
export function getSessionStorageItem (a) {
  return window.sessionStorage.getItem(a)
}
export function setSessionStorageItem (a, b) {
  window.sessionStorage.setItem(a, b)
}
export function removeSessionStorageItem (a) {
  return window.sessionStorage.removeItem(a)
}
export function getLocalStorageItem (a) {
  return window.localStorage.getItem(a)
}
export function setLocalStorageItem (a, b) {
  window.localStorage.setItem(a, b)
}
export function removeLocalStorageItem (a) {
  return window.localStorage.removeItem(a)
}
